import MainView from '../components/Layout/MainView.vue'
import Login from '../components/Account/Login.vue'
import NotFound from '../components/Shared/NotFoundPage.vue'
import Home from '../components/Home/Home.vue';
import Trainings from '../components/Trainings/Trainings.vue';
import Users from '../components/Users/Users.vue';
import AddUser from '../components/Users/Add/AddUser.vue';
import EditUser from "../components/Users/Edit/EditUser.vue";
import UserPayment from "../components/Users/Payment/UserPayment.vue";
import AddPayment from "../components/Users/Payment/Add/AddPayment.vue";
import Term from "../components/Term/Term.vue";
import AddTerm from "../components/Term/Add/AddTerm.vue";
import EditTerm from "../components/Term/Edit/EditTerm.vue";
import AddTraining from "../components/Trainings/Add/AddTraining.vue";
import ViewTrainings from "../components/Trainings/View/ViewTrainings.vue";
import EditTraining from "../components/Trainings/Edit/EditTraining.vue";
import TrainingReport from "../components/TrainingReport/TrainingReport.vue";
import EditPayment from "../components/Users/Payment/Edit/EditPayment.vue";
import AcceptTerms from "../components/Account/AcceptTerms.vue";
import Rules from "../components/Account/Rules.vue";
import Notification from "../components/Notification/Notification.vue";
import ResetPassword from "../components/Account/ResetPassword.vue";
import OpenTerms from "../components/Term/Open/OpenTerms.vue";
import PaymentReport from "../components/Payment/PaymentReport.vue";
import Terms from "../components/Account/Terms.vue";
import Company from "../components/Company/Company.vue";
import EditCompany from "../components/Company/Edit/EditCompany.vue";
import CompanyPayment from "../components/CompanyPayment/CompanyPayment.vue";
import AddEditCompanyPayment from "../components/CompanyPayment/AddEditCompanyPayment.vue";
import AdditionalKits from "../components/Users/Payment/AdditionalKits.vue";
import DeleteAccount from "../components/Account/DeleteAccount.vue";
import TrainingTypes from "../components/Users/Payment/TrainingTypes.vue";
import Configuration from "../components/Company/Configuration.vue";
import HomeFiskultura from "../components/Home/HomeFiskultura.vue";
import HomePage from "../components/Home/HomePage.vue";
import CONFIG_COMPANY from "../services/myConfig";
import Profile2 from "../components/Users/Profile/Profile2.vue";
import EditProfile from "../components/Users/Profile/EditProfile.vue";
import MyPayments from "../components/Users/Profile/MyPayments.vue";
import MembershipPackages from "../components/Membership/MembershipPackages.vue";
import AddMembershipPackage from "../components/Membership/AddMembership/AddMembershipPackage.vue";
import EditMembership from "../components/Membership/EditMembership/EditMembership.vue";
import BuyMembershipPackages from "../components/Membership/BuyMembershipPackages.vue";
import Invoices from "../components/Invoice/Invoices.vue";
import InvoiceReport from "../components/Invoice/InvoiceReport.vue";
import AddInvoice from "../components/Invoice/Add/AddInvoice.vue";
import AddMembershipCategory from "../components/Membership/AddMembershipCategory.vue";
import AddTrainingInfo from "../components/Home/Add/AddTrainingInfo.vue";
import AddTrainerInfo from "../components/Home/Add/AddTrainerInfo.vue";
import AddNutritionInfo from "../components/Home/Add/AddNutritionInfo.vue";
import Articles from "../components/Article/Articles.vue";
import AddArticle from "../components/Article/Add/AddArticle.vue";
import ArticleCategories from "../components/Article/ArticleCategories.vue";
import AddShopInfo from "../components/Home/Add/AddShopInfo.vue";
import Entrance from "../components/Entrance/Entrance.vue";
import DoorConfiguration from "../components/Company/DoorConfiguration.vue";
import Orders from "../components/Order/Orders.vue";
import Wod from "../components/Wod/Wod.vue";
import Personal from "../components/Personal/Personal.vue";
import WodProgram from "../components/Wod/WodProgram.vue";
import AllWodTrainings from "../components/Wod/AllWodTrainings.vue";
import AllPersonalTrainings from "../components/Personal/AllPersonalTrainings.vue";
import AddPersonalProgram from "../components/Personal/AddPersonalProgram.vue";
import PersonalAdminProgram from "../components/Personal/PersonalAdminProgram.vue";
import PersonalListProgramUser from "../components/Personal/PersonalListProgramUser.vue";
import PersonalUserDetailsProgram from "../components/Personal/PersonalUserDetailsProgram.vue";
import CompanyPartner from "../components/CompanyPartner/CompanyPartner.vue";
import AddEditCompanyPartner from "../components/CompanyPartner/AddEditCompanyPartner.vue";
import CopyPersonalProgram from "../components/Personal/CopyPersonalProgram.vue";
import UserCredit from "../components/UserCredit/UserCredit.vue";
import AddCompany from "../components/Company/Add/AddCompany.vue";
import AdminDocs from "../components/AdminDocs/AdminDocs.vue";
import WodUserResults from "../components/Wod/WodUserResults.vue";
import ShopPage from "../components/Shop/ShopPage.vue";
import ShopPageQr from "../components/Shop/ShopPageQr.vue";
import Translation from "../components/Company/Translation.vue";
import AddEventInfo from "../components/Home/Add/AddEventInfo.vue";
import SignUpForEvent from "../components/Home/Event/SignUpForEvent.vue";
import AllEventItems from "../components/Home/Event/AllEventItems.vue";
import EmployedUsers from "../components/Users/EmployedUsers/EmployedUsers.vue";
import TrainingNotes from "../components/TrainingNotes/TrainingNotes.vue";
import CSchedule from "../components/CSchedule/CSchedule.vue";
import Campaign from "../components/Campaign/Campaign.vue";
import CampaignList from "../components/Campaign/CampaignList.vue";
import CompanyCampaign from "../components/Campaign/CompanyCampaign.vue";
import TrainerReport from "../components/TrainingReport/TrainerReport.vue";
import OrdersReservation from "../components/Order/OrdersReservation.vue";
import ArticlesReport from "../components/Article/ArticlesReport.vue";
import PersonalListProgramNewUser from "../components/Personal/PersonalListProgramNewUser.vue";
import TimedSlot from "../components/TimedSlot/TimedSlot.vue";
import BarPos from "../components/BarPos/BarPos.vue";
import PersonalProgramResults from "../components/Personal/PersonalProgramResults.vue";
import UserProfile from "../components/Users/UserProfile/UserProfile.vue";
import SubscriptionReport from "../components/SubscriptionReport/SubscriptionReport.vue";
import AddKnowledgeInfo from "../components/Home/Add/AddKnowledgeInfo.vue";
import KnowledgeDetails from "../components/Home/Knowledge/KnowledgeDetails.vue";
import WarehouseShopItem from "../components/Warehouse/WarehouseShopItem.vue";
import AddEditWarehouseShopItem from "../components/Warehouse/AddEditWarehouseShopItem.vue";
import Profit from '../components/Report/Profit.vue';
import UserReport from "../components/Report/UserReport.vue";
import InventoryHistory from "../components/Inventory/InventoryHistory.vue";
import AddNewInventory from "../components/Inventory/AddNewInventory.vue";
import PersonalUserDetailsProgramNew from "../components/Personal/PersonalUserDetailsProgramNew.vue";
import BarSaldoDebtorsReport from "../components/Report/BarSaldoDebtorsReport.vue";

const routes = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            roles: [
                "ADMIN",
                "DEFAULT"
            ]
        }

    }, {
        path: '/terms',
        component: Terms,
        name: 'terms',
        meta: {
            roles: [
                "ADMIN",
                "DEFAULT"
            ]
        }
    },
    {
        path: '/',
        component: MainView,
        redirect: ''+ CONFIG_COMPANY.HOME,
        children: [
            {
                path: '/home',
                component: Home,
                name: 'home',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/home-page',
                component: HomePage,
                name: 'home-page',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/home-fiskultura',
                component: HomeFiskultura,
                name: 'home-fiskultura',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/trainings',
                component: Trainings,
                name: 'trainings',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/users',
                component: Users,
                name: 'users',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-user',
                component: AddUser,
                name: 'addUser',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-user',
                component: EditUser,
                name: 'editUser',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/payment-user',
                component: UserPayment,
                name: 'paymentUser',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/my-payments',
                component: MyPayments,
                name: 'my-payments',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-payment',
                component: AddPayment,
                name: 'addPayment',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-payment',
                component: EditPayment,
                name: 'editPayment',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/profile',
                component: Profile2,
                name: 'profile',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-profile',
                component: EditProfile,
                name: 'edit-profile',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/pre-terms',
                component: Term,
                name: 'pre-term',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-term',
                component: AddTerm,
                name: 'addTerm',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-term',
                component: EditTerm,
                name: 'editTerm',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-training',
                component: AddTraining,
                name: 'addTraining',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/view-trainings',
                component: ViewTrainings,
                name: 'viewTrainings',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-training',
                component: EditTraining,
                name: 'editTraining',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/training-report',
                component: TrainingReport,
                name: 'trainingReport',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/accept-terms',
                component: AcceptTerms,
                name: 'acceptTerms',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/rules',
                component: Rules,
                name: 'rules',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/notification',
                component: Notification,
                name: 'notification',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/reset-password',
                component: ResetPassword,
                name: 'resetPassword',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/open-terms',
                component: OpenTerms,
                name: 'openTerms',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/payment-report',
                component: PaymentReport,
                name: 'paymentReport',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/company-payment',
                component: CompanyPayment,
                name: 'company-payment',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-company-payment',
                component: AddEditCompanyPayment,
                name: 'add-company-payment',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/companies',
                component: Company,
                name: 'companies',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-company',
                component: EditCompany,
                name: 'edit-company',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/delete-account',
                component: DeleteAccount,
                name: 'delete-account',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/additional-kits',
                component: AdditionalKits,
                name: 'additional-kits',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/training-types',
                component: TrainingTypes,
                name: 'training-types',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/membership-packages',
                component: MembershipPackages,
                name: 'membership-packages',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/buy-membership-packages',
                component: BuyMembershipPackages,
                name: 'buy-membership-packages',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-membership-package',
                component: AddMembershipPackage,
                name: 'add-membership-package',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/edit-membership-package',
                component: EditMembership,
                name: 'edit-membership-package',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/invoices',
                component: Invoices,
                name: 'invoices',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-invoice',
                component: AddInvoice,
                name: 'add-invoice',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/invoice-report',
                component: InvoiceReport,
                name: 'invoice-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-membership-category',
                component: AddMembershipCategory,
                name: 'add-membership-category',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },

            {
                path: '/add-training-company-info',
                component: AddTrainingInfo,
                name: 'add-training-company-info',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-trainer-company-info',
                component: AddTrainerInfo,
                name: 'add-trainer-company-info',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-nutrition-company-info',
                component: AddNutritionInfo,
                name: 'add-nutrition-company-info',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-shop-company-info',
                component: AddShopInfo,
                name: 'add-shop-company-info',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/articles',
                component: Articles,
                name: 'articles',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/article-categories',
                component: ArticleCategories,
                name: 'article-categories',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-article',
                component: AddArticle,
                name: 'add-article',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/config-company',
                component: Configuration,
                name: 'config-company',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/entrance',
                component: Entrance,
                name: 'entrance',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/door-config',
                component: DoorConfiguration,
                name: 'door-config',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/orders',
                component: Orders,
                name: 'orders',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/wod',
                component: Wod,
                name: 'wod',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal',
                component: Personal,
                name: 'personal',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/wod-program',
                component: WodProgram,
                name: 'wod-program',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/all-wod-trainings',
                component: AllWodTrainings,
                name: 'all-wod-trainings',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/all-personal-trainings',
                component: AllPersonalTrainings,
                name: 'all-personal-trainings',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-personal-program',
                component: AddPersonalProgram,
                name: 'add-personal-program',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/copy-personal-program',
                component: CopyPersonalProgram,
                name: 'copy-personal-program',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal-admin-program',
                component: PersonalAdminProgram,
                name: 'personal-admin-program',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal-user-details-program',
                component: PersonalUserDetailsProgram,
                name: 'personal-user-details-program',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal-user-details-program-new',
                component: PersonalUserDetailsProgramNew,
                name: 'personal-user-details-program-new',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal-list-program-user',
                component: PersonalListProgramUser,
                name: 'personal-list-program-user',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal-list-program-new-user',
                component: PersonalListProgramNewUser,
                name: 'personal-list-program-new-user',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/company-partner',
                component: CompanyPartner,
                name: 'company-partner',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-company-partner',
                component: AddEditCompanyPartner,
                name: 'add-company-partner',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/user-credits',
                component: UserCredit,
                name: 'user-credits',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-company',
                component: AddCompany,
                name: 'add-company',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/admin-instruction',
                component: AdminDocs,
                name: 'admin-instruction',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/wod-user-results',
                component: WodUserResults,
                name: 'wod-user-results',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/shop',
                component: ShopPage,
                name: 'shop',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/shop-qr',
                component: ShopPageQr,
                name: 'shop-qr',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/translations',
                component: Translation,
                name: 'translations',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-event-company-info',
                component: AddEventInfo,
                name: 'add-event-company-info',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/sign-up-for-event',
                component: SignUpForEvent,
                name: 'sign-up-for-event',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/all-event-items',
                component: AllEventItems,
                name: 'all-event-items',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/employed-users',
                component: EmployedUsers,
                name: 'employed-users',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/employed-terms',
                component: Term,
                name: 'employed-terms',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/user-notes',
                component: TrainingNotes,
                name: 'user-notes',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/c-schedule',
                component: CSchedule,
                name: 'c-schedule',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-campaign',
                component: Campaign,
                name: 'add-campaign',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-company-campaign',
                component: CompanyCampaign,
                name: 'add-company-campaign',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/campaign-list',
                component: CampaignList,
                name: 'campaign-list',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/trainer-report',
                component: TrainerReport,
                name: 'trainer-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/orders-reservation',
                component: OrdersReservation,
                name: 'orders-reservation',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/articles-report',
                component: ArticlesReport,
                name: 'articles-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/timed-slots',
                component: TimedSlot,
                name: 'timed-slots',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/bar-pos',
                component: BarPos,
                name: 'bar-pos',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/personal-program-results',
                component: PersonalProgramResults,
                name: 'personal-program-results',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/user-profile',
                component: UserProfile,
                name: 'user-profile',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/subscription-report',
                component: SubscriptionReport,
                name: 'subscription-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-knowledge-company-info',
                component: AddKnowledgeInfo,
                name: 'add-knowledge-company-info',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/knowledge-details',
                component: KnowledgeDetails,
                name: 'knowledge-details',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/warehouses',
                component: WarehouseShopItem,
                name: 'warehouses',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-warehouse-shop-item',
                component: AddEditWarehouseShopItem,
                name: 'add-warehouse-shop-item',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/inventory-history',
                component: InventoryHistory,
                name: 'inventory-history',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/add-new-inventory',
                component: AddNewInventory,
                name: 'add-new-inventory',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/profit',
                component: Profit,
                name: 'profit',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/user-report',
                component: UserReport,
                name: 'user-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/campaign-company',
                component: CompanyCampaign,
                name: 'campaign-company',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/bar-saldo-debtors',
                component: BarSaldoDebtorsReport,
                name: 'bar-saldo-debtors',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            }
        ]
    },
    {
        path:
        '*',
        component: NotFound,
    }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js